module.exports = __WEBPACK_EXTERNAL_MODULE_49__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ko","commonjs":"knockout","commonjs2":"knockout","amd":"knockout"}
// module id = 49
// module chunks = 2